import { Box, Heading, smBumps, xsBumps } from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'

import { CoverOption, isAuxiliary, Quote } from '../../../domain'
import { useCoverLevelOption } from '../../../hooks/coverOption'
import { useOptionalCovers } from '../../../hooks/covers'
import { TKey, useWriskTranslation } from '../../../infrastructure/internationalisation'
import { useProduct } from '../../product/ProductProvider'
import { OptionalFlexAnchor } from './OptionalFlexAnchor'

const tKey = TKey('components.optional-cover-items')

export interface OptionalCoverItemsProps {
  quote: Quote
  onChange?: (coverOption: CoverOption) => void
}

export const OptionalCoverItems: FunctionComponent<OptionalCoverItemsProps> = ({
  quote,
  onChange,
}) => {
  const { t } = useWriskTranslation()

  const { product } = useProduct()
  const { coverLevelOption } = useCoverLevelOption(quote, product)

  const optionalCovers = useOptionalCovers(quote, product).filter(
    isAuxiliary(product, coverLevelOption),
  )

  return optionalCovers.length ? (
    <Box width={1} p={2} borderTopWidth={1}>
      <Heading mt={2} px={smBumps} pb={xsBumps} variant='h3'>
        {t(tKey('header'))}
      </Heading>
      <Box width={1}>
        {optionalCovers.map((coverOption) => (
          <OptionalFlexAnchor
            key={coverOption.coverOption}
            coverOption={coverOption}
            quote={quote}
            onChange={onChange}
          />
        ))}
      </Box>
    </Box>
  ) : null
}
